(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('ComparisonChartTitleCtrl', ComparisonChartTitleCtrl);

  // @ngInject
  function ComparisonChartTitleCtrl() {
    var vm = this;

    vm.updateLegendCheckbox = function() {
      vm.checkBoxes = _(vm.options.series)
          .map(function (s) {
            return _.pick(s, ['name', 'visible', 'className']);
          }).uniqBy('name').value();

      vm.legendGroups = _(vm.options.series)
          .groupBy(function (series) {
            return series.custom.groupIndex;
          })
          .map(function (values, key) {
            return {
              name: vm.options.groupNames && vm.options.groupNames[key],
              colorClasses: _.map(values, 'className'),
              marker: key > 0
            }
          })
          .value();
    };

    vm.onSeriesCheckboxClick = function (key) {
      var isVisible = _.find(vm.options.series, {name: key}).visible;
      _(vm.options.series).filter({name: key}).forEach(function (s) {
        s.visible = !isVisible;
      });
    };

  }
  })();
